/** @format */

import { push } from 'connected-react-router';
import { brokerLoginApiService } from 'services/apiService';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as actionTypes from 'stateContainer/action-types';
import moment from 'moment';

const FIRST_TIME_LOGIN = 'FirstTimeLoginResetPassword';

function* workerSaga({ payload }) {
  try {
    const response = yield call(brokerLoginApiService, payload);
    const isSuccess = response.data?.status === 'success';
    if (isSuccess) {
      const accessToken = response.data.data.AuthenticationResult?.AccessToken;
      const refreshToken =
        response.data.data.AuthenticationResult?.RefreshToken;
      const userData = response.data.data?.userData;
      const expiresInSeconds =
        response.data.data.AuthenticationResult?.ExpiresIn;

      yield put({
        type: actionTypes.LOGIN_SUCCESS,
        data: {
          accessToken,
          refreshToken,
          userData
        },
        sessionEndTime: moment().add(expiresInSeconds, 'seconds').toDate()
      });
    } else {
      throw new Error();
    }

    yield put(push(payload.successUrl));
  } catch (error) {
    const errorObject = error.response.data?.error || null;
    const errorName = errorObject?.name;
    const errorHasCode = errorObject?.code;
    const isFirstTimeLogin = errorName === FIRST_TIME_LOGIN;
    const isTemporaryPasswordExpiryError = (() => {
      if (
        errorObject?.message !== undefined &&
        typeof errorObject?.message === 'string'
      ) {
        return errorObject?.message.includes('Temporary password has expired');
      }
      return false;
    })();

    let errorCode = 'General';

    if (errorName) {
      errorCode = errorObject.name;
    }
    if (errorHasCode) {
      if (isTemporaryPasswordExpiryError) {
        errorCode = 'TemporaryPasswordExpired';
      } else {
        errorCode = errorObject.code;
      }
    }

    yield put({
      type: actionTypes.LOGIN_FAILED,
      error,
      errorCode
    });
    if (isFirstTimeLogin) {
      yield put({
        type: actionTypes.SAVE_USERNAME,
        username: payload.username,
        password: payload.password,
        session: errorObject && errorObject.data.Session
      });
      yield put(push(payload.changePasswordUrl));
      return;
    }

    yield put(push(payload.failedUrl));
  }
}

export function* loginSaga() {
  yield takeLatest(actionTypes.LOGIN_REQUESTED, workerSaga);
}
